import type { TFunction } from "i18next";
import { toast } from "react-toastify";
import CopyButton from "./form/copy_button";

const ERROR_CODE_BASE_PATH = "error_codes";

export const create_error_code_toast = (
	t: TFunction,
	errorCode?: string,
	errorMessage?: string,
) => {
	const errorCodeTranslation = determErrorCodeTranslation(t, errorCode, errorMessage);
	const isErrorCodeAvailable = errorCode;

	return toast.error(
		<>
			<ErrorBase t={t} error_code_translation={errorCodeTranslation} />
			{isErrorCodeAvailable && <ErrorCode t={t} error_code={errorCode} />}
		</>,
	);
};

/* -------------------------------------------------------------------------- */
/*                              HELPER FUNCTIONS                              */
/* -------------------------------------------------------------------------- */
function determErrorCodeTranslation(
	t: TFunction,
	errorCode?: string,
	errorMessage?: string,
): string {
	if (isUnknownError(errorCode, errorMessage)) {
		return t("validation.errors.unknown");
	}

	if (isErrorCodeTranslated(t, errorCode)) {
		return readErrorCodeTranslation(t, errorCode);
	}

	return errorMessage;
}

function readErrorCodeTranslation(t: TFunction, errorCode: string) {
	return t(`${ERROR_CODE_BASE_PATH}.${errorCode}`);
}

function isUnknownError(errorCode?: string, errorMessage?: string): boolean {
	return !(errorCode || (errorMessage && typeof errorMessage === "string")); // errorMessage must be a string, because it being an object or array will crash React
}
function isErrorCodeTranslated(t: TFunction, errorCode?: string): boolean {
	if (!errorCode) {
		return false;
	}

	const errorCodeTranslation = t(`${ERROR_CODE_BASE_PATH}.${errorCode}`, { defaultValue: "" });

	return errorCodeTranslation.length > 0;
}

/* -------------------------------------------------------------------------- */
/*                                 COMPONENTS                                 */
/* -------------------------------------------------------------------------- */
type ErrorBaseProps = {
	t: TFunction;
	error_code_translation: string;
};
function ErrorBase({ t, error_code_translation }: ErrorBaseProps): JSX.Element {
	return (
		<>
			<strong>{t("error_codes.error_msg")}:</strong>
			<br />
			{error_code_translation}
			<br />
			<br />
		</>
	);
}

type ErrorCodeProps = {
	t: TFunction;
	error_code?: string;
};

function ErrorCode({ t, error_code }: ErrorCodeProps) {
	return (
		<>
			<span style={{ color: "#ddd", fontSize: "0.8rem" }}>
				<strong>{t("error_codes.error_code")}:</strong>
			</span>
			<br />
			<span style={{ color: "#ddd", fontSize: "0.73rem" }}>{error_code}</span>{" "}
			<CopyButton value={error_code} icon_sx={{ color: "#ddd", fontSize: "1.3rem" }} />
		</>
	);
}
